// src/components/shared/LoadingState.jsx
import React from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import Typography from '@mui/material/Typography';

const LoadingState = ({ loading, error, children, loadingMessage = "Cargando..." }) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 3 }}>
        <CircularProgress size={24} sx={{ mr: 2 }} />
        <Typography variant="body2">{loadingMessage}</Typography>
      </Box>
    );
  }
  
  if (error) {
    return (
      <Alert severity="error" sx={{ m: 2 }}>
        {error}
      </Alert>
    );
  }
  
  return children;
};

export default LoadingState;